export default function CommunEditModal(props) {
  return (
    <>
      {props.showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="md:w-1/3 w-full border-0 rounded-lg shadow-lg relative  bg-white outline-none focus:outline-none">
              <div className="flex items-start justify-between  p-3 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-lg font-semibold">{props.Title}</h3>
                <button
                  title="Close"
                  className="p-1 ml-auto bg-transparent border-0 text-black float-right text-lg leading-none font-semibold outline-none focus:outline-none"
                  onClick={() => props.setShowModal(false)}
                >
                  <span className="bg-transparent text-red-500 h-6 w-6 text-lg block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
              </div>
              <div className="items-start justify-between border-b border-solid border-slate-200 rounded-t">
                {props.children}
              </div>
            </div>
          </div>
          <div className="opacity-60 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
